<template>
    <div>
        <h1>Frontend Goes Serverless!</h1>
        <p>Congrats! You now have:</p>
        <ul>
            <li>A beautiful <i>web app</i> written with a modern framework</li>
            <li>It has a <i>build</i> that delivers static files <i>perfect for serverless hosting</i></li>
        </ul>

        
        <AwsAccount></AwsAccount>


        <h3>Create an <i>S3 Bucket</i></h3>
        <p>In the AWS console, search for S3, and chose to create a new bucket. Make sure you do it in the correct region (you probably want it in eu-north-1, i.e. Stockholm)</p>
        <p>You in the properties of the bucket, you can chose to enable <i>Static website hosting</i>, choose <i>index.html</i> as both index document and error document (for now).</p>
        <p>You should now se an <i>Endpoint</i> being displayed, something like http://<i>yourbucketname</i>.s3-website.eu-north-1.amazonaws.com</p>
        <p>Upload the entire contents of your <i>dist/</i> folder into the bucket root, i.e. index.html should be in the root. Be sure to enable <i>Grant public read access to this object(s)</i> and don't upload any secret stuff.</p>
        <p>Visiting the endpoint above shall now display your app.</p>


        <h3>Createt a <i>CouldFront Distribution</i></h3>
        <p>To be able to use <i>HTTPS</i>, and to customize routing (e.g. supporting reload of the site while not being in the root (/) which most likely is the case as you should use HTML5 history) you will need to create a CloudFront distribution.</p>
        <p>It is a <i>CDN</i> with support for <i>TLS</i>, <i>redirects</i>, <i>custom response codes</i>, and <i>edge caching</i> for whopping speeds!</p>
        <p>As <i>Origin</i>, choose your S3 bucket.</p>
        <p>Use the Default CloudFront Certificate (unless you have your own domain name, like a pro!)</p>
        <p>Since you are security aware, use the highest TLS-setting (most likely <i>TLS 1.2</i>+), and also redirect HTTP to HTTPS wherever that setting could be...</p>
        <p>Why not enable <i>HTTP/2</i> and <i>IPv6</i></p>
        <p>Most other stuff can be left default.</p>
        <p>For a better user experience, create two custom error responses (the Error Pages tab), use 403 and 404, and set /index.html as Response Page Path and 200 as Response Code.</p>
        <p>Yeah, that sounds wierd, I know. But it makes things look and work better in this simplified setup...</p>

        <p>You should now have something like <a href="https://d2jm0gid1du30e.cloudfront.net" target="_blank">d2jm0gid1du30e.cloudfront.net</a> but with your own ID. By the way, that is the distribution hosting this website!</p>
        
        <h3>Voilà! #Tadaaaa!</h3>
        <p>There you have it! <b><i>High-Five!</i></b></p>
        <p>You have succeeded in creating a website in the cloud <i>"Serverless"</i> <span class="comment">/* BuzzWordWarning */</span>. If you haven't done anything more, then this should be free for one year and after that a few cents per month.</p>
        <p>Send an email to your collegues, write a few lines in  <a href="https://afitwest.slack.com/archives/CREFZN18C" target="_blank">#serverless-kitchen</a> and show them what you have accomplished!</p>
        <p>Invite some <router-link to="/test">Testers</router-link> to test your app, or level up and <router-link to="/test">Do it yourself</router-link>!</p>
        <p>Invite some <router-link to="/backend">Backenders</router-link> to use your GUI for their backend, or level up and <router-link to="/backend">Do it yourself</router-link>!</p>
    </div>
</template>


<script>
import AwsAccount from '@/components/AwsAccount.vue'

export default {
    name: 'FrontendVue',
    components: {
        AwsAccount
    }
}
</script>